import React from 'react'
import Changes from '../../changes/Changes'

const TabChanges = ({ changes }) => {
  return (
    <Changes
		changes={changes}
	/>
  )
}

export default TabChanges